module.exports = [{
      plugin: require('/Users/nate/repos/vx/vuplex-web/support.vuplex.com/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
